export const levelOne = `
## Øk kunnskapen
Det ikke barnets feil! Små problemer kan vokse seg store, og hjelp til å forstå problemet gjør ting lettere! Les mer!
`

export const levelTwo = `
## Endre rutiner
Noen ganger kan enkle grep hjelpe. Gode drikke- og toalettvaner på dagtid, og et variert kosthold er viktig! Les mer!
`

export const levelThree = `
## Få hjelp
Ta opp problemet med helsesøster eller barnets lege. Det kan ha en medisinsk årsak, og det finnes alternativer som kan hjelpe! Les mer!
`



// WEBPACK FOOTER //
// ./src/containers/Conclusion/text.js